import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet';

import ContentWrapper from '../components/contentWrapper';
import SidePanel from '../components/sidePanel';
import MainPanelCard from '../components/mainPanelCard';

import styles from '../styles/pagesComponents/pageWithCards.module.scss';

const PageComponent = ({ data, intl, messageId }) => {
  let mainCards = null;

  if (data.allMarkdownRemark != null) {
    const blogPosts = data.allMarkdownRemark.edges;

    mainCards = blogPosts.map(({ node }) => (
      <MainPanelCard
        key={node.frontmatter.title}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...node.frontmatter}
      />
    ));
  } else {
    mainCards = (
      <div className={styles.emptyQuery}>
        <FormattedMessage
          id="category.emptyQuery"
        />
      </div>
    );
  }

  return (
    <ContentWrapper>
      {messageId && (
        <Helmet>
          <title>{intl.formatMessage({ id: `category.${messageId}` })}</title>
          <meta name="description" content={intl.formatMessage({ id: `meta.description.${messageId}` })} />
          <meta property="og:title" content={intl.formatMessage({ id: `category.${messageId}` })} />
          <meta property="og:description" content={intl.formatMessage({ id: `meta.description.${messageId}` })} />
        </Helmet>
      )}
      {!messageId && (
        <Helmet>
          <meta name="description" content={intl.formatMessage({ id: 'meta.description.home' })} />
          <meta property="og:title" content="MSF Blog" />
          <meta property="og:description" content={intl.formatMessage({ id: 'meta.description.home' })} />
        </Helmet>
      )}
      <SidePanel />
      <div className={styles.mainCardContainer}>
        {messageId && (
          <div className={styles.title}>
            <FormattedMessage id={`category.${messageId}`} />
          </div>
        )}
        {mainCards}
      </div>
    </ContentWrapper>
  );
};

PageComponent.defaultProps = {
  messageId: null,
};

PageComponent.propTypes = {
  data: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  messageId: PropTypes.string,
};

export default injectIntl(PageComponent);
